import gql from 'graphql-tag';

export default gql`
  query downloadDeliveryNote($input: DownloadDeliveryNoteInput!) {
    downloadDeliveryNote(input: $input) {
      data
    }
  }
`;
